var map = {
	"./ALMA-NEGRA-BLANCO.png": 5271,
	"./ARROGANTE.png": 5825,
	"./ARUMA.png": 3626,
	"./BRAMARE-LUJAN-DE-CUYO-MALBEC.png": 6527,
	"./COCODRILO.png": 9102,
	"./COQUENA-ROSADO.png": 6453,
	"./DV-CATENA-ADRIANNA.png": 6256,
	"./DV-CATENA-TINTO-HISTORICO.png": 7723,
	"./EMMA-ZUCCARDI-BONARDA.png": 904,
	"./FELINO-MALBEC.png": 6490,
	"./JUDAS-BLEND.png": 8749,
	"./LUIGI-BOSCA-BRUT-NATURE.png": 1333,
	"./LUIGI-BOSCA-CHARDONNAY.png": 7947,
	"./LUIGI-BOSCA-DE-SANGRE-BLEND.png": 4706,
	"./LUIGI-BOSCA-DE-SANGRE-DOC.png": 5513,
	"./LUIGI-BOSCA-MALBEC.png": 6702,
	"./LUIGI-BOSCA-NOBLES-MALBEC.png": 4500,
	"./LUIGI-BOSCA-PINOT-NOIR.png": 815,
	"./LUIGI-BOSCA-ROSE.png": 795,
	"./MIL-DEMONIOS-PINOT.png": 2508,
	"./MONTEAGRELO-SYRAH.png": 2855,
	"./PIATELLI-RESERVA-MALBEC-SALTA.png": 8880,
	"./PIZZELLA-MALBEC.png": 3642,
	"./RUTINI-CABERNET-FRANC-MALBEC.png": 4274,
	"./RUTINI-CHARDONNAY.png": 357,
	"./RUTINI-DOUX.png": 8276,
	"./SAN-PEDRO-YACOCHUYA-TINTO.png": 8443,
	"./SAN-PEDRO-YACOCHUYA-TORRONTES.png": 6713,
	"./SOTTANO-RESERVA-DE-FAMILIA.png": 9193,
	"./SUSANA-BALBO-BRIOSSO.png": 4574,
	"./SUSANA-BALBO-ROSE.png": 1570,
	"./YACOCHUYA.png": 2270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4271;